import { useMutation } from '@tanstack/react-query'

import { useSharedDates } from '@contexts/sharedDates'
import { useDate } from '@hooks/dates'
import { useFindProfile } from '@hooks/profile'
import { IPostTask } from '@interfaces/task/downstream/post/IPostTask'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'
import { api } from '@services/apiClient'
import { queryClient } from '@services/queryClient'

export function useAddTask() {
  const { data: user } = useFindProfile()
  const { selectedDate } = useSharedDates()
  const { getWeekRange } = useDate()

  const { weekStart } = getWeekRange(selectedDate)
  const siteId = user && user.selectedSite.id

  const postTask = async (task: IPostTask) => {
    const url = `/sites/${siteId}/tasks`

    const { data } = await api.post<IGenericTask>(url, task)

    return data
  }

  return useMutation({
    mutationFn: postTask,
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['TASKS', weekStart.getTime()],
        type: 'active',
      })
    },
  })
}
